<!--
   Created by qing on 2021/2/6
   Des: 
-->
<template>
  <div>

    <div
      class="order-item"
      v-for="item in orderList"
      :key="item.orderId">

      <div class="order-item-wrapper">
        <div class="order-num">
          订单号：{{item.orderId}}
        </div>
        <div class="order-info">
          <div class="content">
            <div class="payment-detail">
              {{item.orderDetail || item.payDetail}}
            </div>
            <div v-if="false" class="info">
              商户名：
            </div>
            <div class="info num-info" v-if="item.thirdOrderId">
              微信订单号：{{item.thirdOrderId}}
            </div>
            <div class="info">
              创建时间：{{formatTime(item.createTime)}}
            </div>
            <div class="info" v-if="item.payTime > 0">
              支付时间：{{formatTime(item.payTime)}}
            </div>
          </div>
          <div class="state">
            <div
              class="payment-state"
              v-if="payStatusMap[item.payStatus]"
              :style="{color: payStatusMap[item.payStatus].color}">
              {{payStatusMap[item.payStatus].label}}
            </div>
            <div class="payment-money">
              ¥{{item.orderMoney}}
            </div>
          </div>
        </div>
        <div class="footer">

          <van-button
            size="small"
            @click="orderDetail(item)">
            查看订单
          </van-button>
          <template v-if="item.payStatus === 'WAIT'">
            <van-button
              size="small"
              @click="orderPay(item)">
              重新支付
            </van-button>
            <van-button
              type="primary"
              size="small"
              @click="closeOrder(item)">
              关闭订单
            </van-button>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {accurateFormatDate} from "../../assets/js/Untis";

  export default {
    props: {
      orderList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {

        payStatusMap: {
          'WAIT': {
            label: '待支付',
            color: '#e6a23c'
          },
          'FINISH': {
            label: '已支付',
            color: '#67c23a'
          },
          'TIMEOUT': {
            label: '已超时',
            color: '#f56c6c'
          },
          'CLOSE': {
            label: '已关闭',
            color: '#909399'
          },
          'REFUNDED': {
            label: '已退款',
            color: '#409eff'
          },
        },
      }
    },
    created() {
    },
    methods: {

      formatTime(d) {
        return accurateFormatDate(d)
      },

      orderDetail(item) {
        this.$router.push({
          name: 'payment_gateway',
          query: {
            o: item.orderId
          }
        })
      },
      // 重新支付
      orderPay(item) {
        this.$store.dispatch('actionCompanyPaymentApplyOrderRetry', {
          orderId: item.orderId,
        }).then(res => {
          this.$router.push({
            name: 'payment_gateway',
            query: {
              o: res.orderId
            }
          })
        }).catch(console.error)
      },
      closeOrder(item) {
        const toast = this.$toast.loading()
        this.$store.dispatch('actionCompanyPaymentApplyOrderClose', {
          orderId: item.orderId
        }).then(res => {
          this.$toast.success('操作成功')
          item.payStatus = 'CLOSE'
        }).catch(console.error)
          .finally(() => {
            toast.clear()
          })
      }
    }
  }
</script>

<style lang="less">

  .order-item {
    width: 100%;
    padding: 10px;

    .order-item-wrapper {
      padding: 10px;
      background-color: #ffffff;
      border-radius: 10px;

      div {
        word-break: break-all;
      }

      .order-num {
        padding-bottom: 10px;
        border-bottom: 1px dashed #e6e6e6;
        font-size: 14px;
        color: #6d6d6d;
      }

      .order-info {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        border-bottom: 1px dashed #e6e6e6;

        .content {
          width: calc(100% - 60px);

          .payment-detail {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
            line-height: 20px;
          }

          .info {
            font-size: 13px;
            color: #959699;
            margin-bottom: 10px;
          }

          .num-info {
            line-height: 20px;
          }
        }

        .state {
          width: 50px;

          .payment-state {
            margin-bottom: 10px;
            font-size: 14px;
          }

          .payment-money {
            font-size: 14px;
            color: #6d6d6d;
          }
        }
      }

      .footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;

        .van-button {
          margin-left: 20px;
          border-radius: 20px;
        }
      }
    }
  }
</style>